// Photos & Map screen (spec §5, §7). Two views — Map and Gallery — switchable via
// the pill toggle, both driven by the same `state.photos` list.

import { iconBadge } from '../lib/icons';
import { state } from '../state';
import { initLeaflet } from '../lib/map';
import { hydratePhotoImages } from '../lib/photoUrls';
import { renderAddButton, renderNav, renderOfflineBanner, emptyState } from './shared';

export function renderMapPhotos(): string {
  const located = state.photos.filter((p) => p.lat != null);
  return `
  <div class="screen">
    ${renderOfflineBanner()}
    <div class="topbar"><div><h1>Photos &amp; Map</h1><div class="sub">${state.photos.length} photos · ${located.length} located</div></div>${renderAddButton()}</div>
    <div class="map-toggle" role="tablist" aria-label="Photos view">
      <button role="tab" aria-selected="${state.mapView === 'map'}" class="${state.mapView === 'map' ? 'active' : ''}" onclick="App.setMapView('map')">Map</button>
      <button role="tab" aria-selected="${state.mapView === 'gallery'}" class="${state.mapView === 'gallery' ? 'active' : ''}" onclick="App.setMapView('gallery')">Gallery</button>
    </div>
    ${
      state.mapView === 'map'
        ? `<div style="padding:14px 20px;">
             <div id="leafletMap" role="img" aria-label="Map of trip photo locations"></div>
             ${!located.length ? `<div class="budget-note" style="margin-top:10px;">No located photos yet — take a photo with location access allowed to see it here.</div>` : ''}
           </div>`
        : renderGallery()
    }
  </div>
  ${renderNav()}`;
}

function renderGallery(): string {
  if (!state.photos.length) return emptyState('image', 'No photos yet', 'Take your first trip photo from the Dashboard.');
  return `<div class="gallery">${state.photos
    .map(
      (p) => `
    <button class="cell" onclick="App.openPhotoDetail('${p.id}')" aria-label="Photo taken ${p.capturedAt.replace('T', ' ')}${p.place ? ', ' + p.place : ''}">
      <img data-photo-id="${p.id}" alt="" loading="lazy"/>
      ${p.lat != null ? `<div class="pin">${iconBadge('marker', { size: 'icon-badge-sm', round: true, iconSize: 12 })}</div>` : ''}
    </button>`
    )
    .join('')}</div>`;
}

export function mountMapPhotos(): void {
  if (state.mapView === 'map') {
    initLeaflet('leafletMap', state.photos);
  } else {
    hydratePhotoImages(document.getElementById('app') || document);
  }
}

export function renderPhotoDetailSheet(id: string): string {
  const p = state.photos.find((x) => x.id === id);
  if (!p) return '';
  return `
    <div class="sheet-head"><h2>Photo</h2><button class="sheet-close" onclick="App.closeSheet()" aria-label="Close">✕</button></div>
    <div class="sheet-body">
      <img data-photo-id-original="${p.id}" alt="" style="width:100%;border-radius:14px;margin-bottom:12px;display:block;background:var(--card-2);aspect-ratio:4/3;object-fit:cover;"/>
      <div class="set-row"><span class="l">Captured</span><span class="r">${p.capturedAt.replace('T', ' ')}</span></div>
      <div class="set-row"><span class="l">Location</span><span class="r">${p.lat != null ? p.place || 'Located' : 'No location saved'}</span></div>
      ${
        p.lat != null && p.lng != null
          ? `<div class="set-row"><span class="l">Coordinates</span><span class="r" style="font-family:var(--mono);font-size:11.5px;">${p.lat.toFixed(4)}, ${p.lng.toFixed(4)}</span></div>`
          : ''
      }
      <div style="height:6px;"></div>
      <button class="btn btn-danger" style="width:100%;" onclick="App.deletePhoto('${p.id}')">Delete photo</button>
    </div>`;
}

export function mountPhotoDetailSheet(): void {
  hydratePhotoImages(document.getElementById('sheetContent') || document);
}
